import { createContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { ILocationProviderProps } from './types';

const LocationContext = createContext(null);
LocationContext.displayName = 'Location Context';

export const LocationProvider = ({ children }: ILocationProviderProps) => {
  const location = useLocation();

  useEffect(() => {
    console.log(location);
  }, [location]);

  return <LocationContext.Provider value={null}>{children}</LocationContext.Provider>;
};
